var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticStyle:{"margin-right":"5px"}},[_c('i',{staticClass:"fas fa-euro-sign fa-spin"})]):_c('div',{staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm.prix)+" € ")])}
var staticRenderFns = []

export { render, staticRenderFns }